import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { MaterialService } from './material.service';
import { Export, ExportList } from '../model/export.model';

@Injectable()
export class ExportsService extends KiwixiService {

  apiExports = environment.server + 'exports/';


  constructor(private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getExportsWithUrl(url): Observable<ExportList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<ExportList>(url, { headers: header }).
      pipe(
        catchError(this.handleErrorObservable<ExportList>(`getExport`))
      );
  }

  getExports(params: HttpParams): Observable<ExportList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<ExportList>(this.apiExports, {
      params,
      headers: header
    })
      .pipe(
        catchError(this.handleErrorObservable<ExportList>(`getExport`))
      );
  }

  exportData(params: HttpParams, endpoint:string): Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiExports + endpoint + '/', {
      params,
      headers: header
    })
  }

  downloadExport(exportId: number): Observable<Blob> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(this.apiExports + `${exportId}/download/`, { responseType: 'blob', headers: header });
  }

  deleteExport(exportId:number):  Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this.http.delete(`${this.apiExports}${exportId}/`);
}

  
}
